import { useUser } from "@/hooks/useUser";

export function HomePage() {
  const { data: user, isLoading, error } = useUser();

  if (isLoading) return <p className="text-ink-muted">Carregando perfil…</p>;
  if (error)
    return (
      <div className="card p-6">
        <h2 className="font-display text-lg font-semibold">Sem provisionamento</h2>
        <p className="mt-2 text-sm text-ink-muted">
          Seu usuário do Entra ID autenticou mas ainda não está cadastrado no Med-Supply.
          Sabrina (DGL) precisa adicionar você à tabela <code>usuario</code> com o papel correto.
        </p>
      </div>
    );

  return (
    <div className="space-y-6">
      <div>
        <h2 className="font-display text-2xl font-semibold text-ink">Bem-vinda, {user?.nome}</h2>
        <p className="text-sm text-ink-muted">
          Você está autenticada como <span className="font-medium text-anarosa">{user?.papel}</span>.
        </p>
      </div>

      <div className="card p-6">
        <h3 className="font-display text-base font-semibold">Atalhos</h3>
        <p className="mt-1 text-sm text-ink-muted">
          Use o menu lateral pra navegar. As telas operacionais (NFs, Requisições,
          Dispensações, Devoluções) ainda estão em construção — entrega na próxima rodada.
        </p>
      </div>
    </div>
  );
}
